import React from 'react';
import styles from './TextDivider.module.css';

export const TextDivider = ({ children }) => {
    return (
        <div className={styles.divider}>
            <div className={`${styles.divider} ${styles.bar}`}></div>
            <div className={`${styles.divider} ${styles.text}`}>{children}</div>
            <div className={`${styles.divider} ${styles.bar}`}></div>
        </div>
    );
};